import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { advBudgetPerformance: { getAdvBudgetPerformance } } = apiUrls;

export const GET_ADV_BUDGET_PERFORMANCE_SUCCESS = 'GET_ADV_BUDGET_PERFORMANCE_SUCCESS';
export const GET_ADV_BUDGET_PERFORMANCE_LOADING = 'GET_ADV_BUDGET_PERFORMANCE_LOADING';


export const getAdvBudgetPerformanceData = ({ fromDate, toDate }) => async (dispatch) => {
    try {
        const { url } = getAdvBudgetPerformance
        const requestData = {
            ...getAdvBudgetPerformance,
            url: url.replace('{{fromDate}}', fromDate).replace('{{toDate}}', toDate)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: GET_ADV_BUDGET_PERFORMANCE_SUCCESS,
            data,
        })
    } catch (e) {

        dispatch({
            type: GET_ADV_BUDGET_PERFORMANCE_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }

}



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: GET_ADV_BUDGET_PERFORMANCE_LOADING,
        isLoading
    })
}
